const EmailType = require('./email-type');

const Types = {
  TRANSPORTER: 1,
  CONSIGNEE: 2,
  MATERIAL: 3,
  BUCC: 4,
  RATEMATRIX: 5,
  DETENTION: 6,
  USER: 7,
  PAYMENT_UPLOAD: 8,
  ORDER: 9,
  MATERIAL_ACROSS_ORDER: 10,
  VEHICLE: 11,
  TRANSITMANAGEMENT: 12,
  CONTRACT: 13,
  OPTIMA_MATERIALS: 14,
  EPOD: 15,
  LOADINGCHARGES: 16,
  SLACHARGES: 17,
  ASSOCIATED_MATERIAL: 18,
  CONTRACT_TSD_MAP: 19,
  CONSIGNEE_OTHER_INFO: 20,
  ORDER_MATERIALS: 21,
  UNKNOWN_MATERIAL: 22,
  PAYMENT_STATUS_UPDATE: 23,
  EXTRA_DROP_OFF_CHARGE: 24,
  DEPOTS: 25,
  GATES: 26,
  BASE_FUEL_RATE: 27, // Changed from BASE_DIESEL_RATE
  OPTIMA_RUN: 28,
  COURIER_INTEGRATION: 29,
  LOCATION: 30,
  PURCHASE_ORDER: 31,
  PORT: 32,
  CHA: 33,
  CONTAINER: 34,
  CONSOLIDATED_MATERIAL_UPLOAD: 35,
  ERP_BULK_INDENT: 36,
  DIRECT_DELIVERY_ORDER_BULK_UPLOAD: 37,
  DIRECT_DISPATCH: 38,
  DIRECT_DISPATCH_CREATION: 39,
  MATERIAL_CATEGORY: 40,
  FREIGHT_PROVISION_POSTING: 41,
  INVOICE_POSTING: 42,
  DEDICATED_TRUCK: 43,
  MATERIAL_INVOICE_GRN: 44,
  DRIVER: 45,
  VEHICLE_BULK: 46,
  VEHICLE_DETAIL: 47,
  TRANSPORTATION_DB: 48,
  BILL_DISCOUNT: 49,
  MATERIAL_INVOICE_WITH_PACKAGE: 50,
  MATERIAL_DELETE_VIA_UPLOAD: 51,
  LOCATION_MILESTONE_UPLOAD: 52,
  DESTINATION_CHARGES_UPLOAD: 53,
  CONSIGNMENT_UPLOAD: 54,
  PRE_PLAN_MATERIAL: 55,
  ADVANCE_SHIPMENT_NOTICE: 56,
  REACH_AND_RELEASE: 57,
  MATERIAL_PACKAGE_MAPPING_MASTER_IMPORT: 58,
  PACKAGE_MASTER_IMPORT: 59,
  ERP_MATERIAL_DELETE: 60,
  GRN_INTERFACE: 61,
  USER_ASSOCIATE: 62,
  GENERATE_OTP: 63,
  INDENT_DISTANCE_UPLOAD: 64,
  BULK_INDENT_UPDATE: 65,
  ERP_TRUCK_OUT: 66,
  ERP_TRUCK_IN: 67,
  ERP_VEHICLE_UPDATE: 68,
  APPROVE_OTP: 69,
  MATERIAL_INVOICE_EPOD: 70,
  TRANSSHIPMENT_IMPORT: 71,
  CHARGEABLE_WEIGHT_BULK_UPLOAD: 72,
  ERP_LORRY_RECEIPT: 73,
  SOURCE_CHARGE_MASTER: 74,
  OPTIMA_MATERIAL_CATEGORY_IMPORTER: 75,
  DELIVERY_PICKLIST_WITH_CONSIGNEE: 76,
  FREIGHT_ZONE_MASTER: 77,
  LEGAL_ENTITY: 78,
  RETURN_WITH_EPOD: 79,
  PAY_SETTLEMENT_UPLOAD: 80,
  OPTIMA_MATERIAL_CATEGORY_VEHICLE_TYPE_IMPORTER: 81,
  VEHICLE_ETA:82,
  VENDOR_DEPOTS: 83,
  DEPOTS_GATES: 84,
};

const exceptionMessage = {
  PAYMENT_STATUS_REFERENCE: 'Invalid reference number or status',
  ERROR_UPDATE_PAID: 'Already in paid status',
  EXTRA_DROP_OFF_CHARGE: 'Invalid depot reference ID',
  ERROR_INVALID_INDENT_OR_STATUS: 'Invalid indent number or status',
};

const exception = {
  exportLimit: 500,
  masterRejection: [
    {
      type: Types.TRANSPORTER,
      label: 'Transporters',
    },
    {
      type: Types.CONSIGNEE,
      label: 'Consignees',
    },
    {
      type: Types.MATERIAL,
      label: 'Materials',
    },
    // {
    //   type: 4,
    //   label: 'Bucc',
    // },
    // {
    //   "type" : 5,
    //   "label": "Rate Matrix",
    // },
    {
      type: Types.DETENTION,
      label: 'Detention',
      permission: 'view_rejection_rate_details',
    },
    {
      type: Types.PURCHASE_ORDER,
      label: 'Purchase Order',
    },
    // {
    //   "type" : 7,
    // "label": "User",
    // },
    // {
    //   "type" : 18,
    //   "label": "Associate Material",
    // },
    {
      type: Types.VEHICLE,
      label: 'Vehicle',
    },
    // {
    //   "type" : 12,
    //   "label": "Transit Management",
    // },
    {
      type: Types.CONTRACT,
      label: 'Rate Matrix',
      permission: 'view_rejection_rate_details',
    },
    {
      type: Types.DRIVER,
      label: 'Driver',
      permission: 'view_driver',
    },
    {
      type: Types.VEHICLE_BULK,
      label: 'Vehicle Details',
    },
    {
      "type" : Types.CONTRACT_TSD_MAP,
      "label": "Contract Tsd Map",
      permission: 'view_contracttsd',
    },
    {
      type: Types.USER_ASSOCIATE,
      label: 'User Associate',
      permission: 'import_material_user_association',
    },
    {
      type: Types.MATERIAL_PACKAGE_MAPPING_MASTER_IMPORT,
      label: 'Material Package Mapping',
      permission: 'import_material_package_map',
    },
    {
      type: Types.USER,
      label: 'User',
    },
    {
      type: Types.VENDOR_DEPOTS,
      label: 'Vendor Depots',
    },
    {
      type: Types.DEPOTS_GATES,
      label: 'Depots Gates',
    }, {
      type: Types.SOURCE_CHARGE_MASTER,
      label: 'Source Charge master',
    }, {
      type: Types.DESTINATION_CHARGES_UPLOAD,
      label: 'Destination Charge master',
    }
  ],
  transactions: [
    {
      type: Types.OPTIMA_MATERIALS,
      label: 'Delivery Pick List',
      exception_last: 1, // days
    },
    {
      type: Types.EPOD,
      label: 'EPOD',
      exception_last: 30, // days
    },
    {
      type: Types.ORDER_MATERIALS,
      label: 'Indent Materials',
      exception_last: 10, // days
    },
    {
      type: Types.PAYMENT_STATUS_UPDATE,
      label: 'Payment status',
      exception_last: 10, // days
    },
    {
      type: Types.COURIER_INTEGRATION,
      label: 'Courier Integration API',
      exception_last: 10, // days
    },
    {
      type: Types.MATERIAL_ACROSS_ORDER,
      label: 'Material Across Order',
      exception_last: 1, // days
    },
    {
      type: Types.ERP_BULK_INDENT,
      label: 'Indents (ERP)',
      exception_last: 30, // days
    },
    {
      type: Types.DIRECT_DISPATCH_CREATION,
      label: 'Direct Dispatch Indent',
      exception_last: 30, // days
    },
    {
      type: Types.FREIGHT_PROVISION_POSTING,
      label: 'Freight Provision posting',
      exception_last: 30, // days
    },
    {
      type: Types.INVOICE_POSTING,
      label: 'Freight Invoice posting',
      exception_last: 30, // days
    },
    {
      type: Types.MATERIAL_INVOICE_GRN,
      label: 'Material Invoice Grn',
      exception_last: 30, // days
    },
    {
      type: Types.MATERIAL_INVOICE_WITH_PACKAGE,
      label: 'Material Invoice With Package',
      exception_last: 30, // days
    },
    {
      type: Types.MATERIAL_DELETE_VIA_UPLOAD,
      label: 'Material Delete Upload',
      exception_last: 30, // days
    },
    {
      type: Types.PRE_PLAN_MATERIAL,
      label: 'Pre-plan Material Upload',
      exception_last: 7, // days
    },
    {
      type: Types.ADVANCE_SHIPMENT_NOTICE,
      label: 'Advance Shipment Notice Upload',
      exception_last: 7, // days
    },
    {
      type: Types.INDENT_DISTANCE_UPLOAD,
      label: 'Indent Distance Upload',
      exception_last: 30, // days
    },
    {
      type: Types.GRN_INTERFACE,
      label: 'Grn Without Reach And Release',
      exception_last: 7, // days
    },
    {
      type: Types.ERP_MATERIAL_DELETE,
      label: 'Material Invoice Delete (ERP)',
      exception_last: 30, // days
    },
    {
      type: Types.REACH_AND_RELEASE,
      label: 'Reach and Release without GRN',
      exception_last: 7, // days
    },
    {
      type: Types.ERP_VEHICLE_UPDATE,
      label: 'Vehicle Driver Details',
      exception_last: 7, // days
    },

    {
      type: Types.ERP_TRUCK_IN,
      label: 'Truck In (ERP)',
      exception_last: 7, // days
    },
    {
      type: Types.ERP_TRUCK_OUT,
      label: 'Truck Out (ERP)',
      exception_last: 7, // days
    },
    {
      type: Types.GENERATE_OTP,
      label: 'Generate Otp for Epod',
      exception_last: 30, //days
    },
    {
      type: Types.ERP_LORRY_RECEIPT,
      label: 'Lorry Receipt (ERP)',
      exception_last: 7, //days
    },
    {
      type: Types.APPROVE_OTP,
      label: 'Approve Otp for Epod',
      exception_last: 30, // days
    },
    {
      type: Types.MATERIAL_INVOICE_EPOD,
      label: 'Material Invoice Epod',
      exception_last: 30, // days
    },
    {
      type: Types.CHARGEABLE_WEIGHT_BULK_UPLOAD,
      label: 'Chargeable Weight Upload',
      exception_last: 30, // days
    },
    {
      type: Types.DELIVERY_PICKLIST_WITH_CONSIGNEE,
      label: 'Delivery Picklist with Consignee'
    },
    {
      type: Types.RETURN_WITH_EPOD,
      label: 'Return With Epod'
    },
  ],
};

const exceptionDetails = {};

exceptionDetails[Types.FREIGHT_PROVISION_POSTING] = {
  name: 'Freight Provision Posting',
  mailType: EmailType.FREIGHT_PROVISION_POSTING,
};

exceptionDetails[Types.INVOICE_POSTING] = {
  name: 'Invoice Posting',
  mailType: EmailType.INVOICE_POSTING,
};

const exceptionEvent = {
  MATERIAL_INVOICE: 'material_invoice',
  PRE_PLAN_MATERIAL: 'pre_plan_material',
  REACH_AND_RELEASE: 'reach_and_release',
  GRN_INTERFACE: 'goods_receipt_note',
  ADVANCE_SHIPMENT_NOTICE: 'advance_shipment_notice',
  DIRECT_DISPATCH: 'direct_dispatch',
};

module.exports = {
  exception,
  Types,
  exceptionMessage,
  exceptionDetails,
  exceptionEvent,
};
